import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  AddMarketingFlowStepPayload,
  MarketingFlowStep
} from "../../marketing.types";
import { requestAddMarketingFlowStep } from "./addMarketingFlowStep.request";

const useAddMarketingFlowStep = (
  options?: MutationOptions<
    MarketingFlowStep,
    ApiServiceError<ApiError>,
    AddMarketingFlowStepPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestAddMarketingFlowStep,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useAddMarketingFlowStep;
